import { createFileRoute } from "@tanstack/react-router"

import { MarketingExportFormPage } from "@/pages/marketing-export-form"

export const Route = createFileRoute("/(marketing)/marketing/exports/new")({
	staticData: {
		breadcrumbKey: "navigation.breadcrumbs.exportCreate",
	},
	component: () => <MarketingExportFormPage mode="create" />,
})
